module.exports =
  '_REGISTRATION':
    'NEW':
      'TITLE': 'Sign up'
      'EMAIL': 'Email address'
      'PASSWORD': 'Password'
      'FIRST_NAME': 'First name'
      'LAST_NAME': 'Last name'
      'BIRTH_DATE': 'Date of birth'
      'MALE': 'Male'
      'FEMALE': 'Female'
      'SIGN_UP': 'Sign up'
      'GENDER': "Gender"
      'COUNTRY': "Country"
      'PREFECTURE': "Prefecture"
      'COUNTRY_DEFAULT_TEXT': "Country"
      'PREFECTURE_DEFAULT_TEXT': "Prefecture"
      'URL_EXPIRED_1': 'URL has expired.'
      'URL_EXPIRED_2': 'Please try again.'
      'PLACEHOLDER_PASSWORD': 'At least 10 characters and contain at least three of uppercase, lowercase, numbers, symbols.'
      'PLACEHOLDER_PASSWORD_COMFIRM': 'Confirmation (Enter the same value as above)'
      'NAME': 'Name'
      'BIRTHDAY': 'Birthday'
      'COUNTRY_TITLE': 'COUNTRY'
      'EMAIL_NEWSLETTER': '	Send mail magazine'
      'CONTENT_EMAIL_NEWSLETTER_1': "We'll send you Golf Network Plus program information and special offers."
      'CONTENT_EMAIL_NEWSLETTER_2': "If you don't want to receive these updates, uncheck the box."
      'CONTENT_EMAIL_NEWSLETTER_3': ""
    'EDIT':
      'TITLE': 'Account'
      'GENERAL': "Setting account"
      'CHANGEPASSWORD': 'Change Password'
      'FORGOTPASSWORD': 'Forgot your password?'
      'EMAIL': '@:_REGISTRATION.NEW.EMAIL'
      'CURRENTPASSWORD': 'Current Password'
      'NEWPASSWORD': 'New Password'
      'CONFIRMPASSWORD': 'Confirm Password'
      'YOURNAME': 'Your name'
      'BIRTH_DATE': '@:_REGISTRATION.NEW.BIRTH_DATE'
      'GENDER': '@:_REGISTRATION.NEW.GENDER'
      'COUNTRY': "@:_REGISTRATION.NEW.COUNTRY"
      'PREFECTURE': "@:_REGISTRATION.NEW.PREFECTURE"
      'CHANGE_EMAIL': 'Click here to change a registered email address'
      'RULE_PASSWORD_LABEL': 'At least 10 characters and contain at least three of uppercase, lowercase, numbers, symbols.'
    'EMAIL':
      'TITLE': 'Sign up'
      'TAPPING_SIGN_UP_FIRST': 'By Tapping Sign Up, you agree to our '
      'TAPPING_SIGN_UP_LAST': ''
      'AND': 'and '
      'TERM': 'Terms '
      'PRIVACE': 'Privacy Policy'
    'EMAIL_SUCCESS':
      'TITLE': 'Sign up'
      'PLEASE_CHECK_EMAIL': 'Please check your authentication email'
      'CHECK_EMAIL_DETAIL': 'An authentication email has been sent to the following email address. Please open the URL in the email and enter your account information.'
      'NOT_RECEIVE_EMAIL': 'If you do not receive an email, please check the following'
      'NOT_RECEIVE_EMAIL_1': '1.Are you sure you entered the correct information?'
      'NOT_RECEIVE_EMAIL_2': '2. It has not arrived in your spam folder.'
      'PLEASE_CONTACT_1': 'If the problem persists, please contact us '
      'PLEASE_CONTACT_2': ''
      'PLEASE_CONTACT_HERE': 'here.'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/registration/i18n/en.coffee